export const WarningCard = () => (
  <div className='p-4 w-full mb-8 bg-tertiary rounded-lg animate-pulse'>
    <div className='flex w-full justify-between'>
      <div className='flex items-center gap-x-2'>
        <div className='w-6 h-6 rounded-full bg-tertiary-light' />
        <div className='w-32 h-4 bg-tertiary-light rounded-sm' />
      </div>
      <div className='w-5 h-5 bg-tertiary-light rounded-sm' />
    </div>
    <div className='mt-2 ml-8 w-64 h-8 bg-tertiary-light rounded-sm' />
  </div>
);
